export const PaymentType = {
  CASH: 'CASH',
  CREDIT_CARD: 'CREDIT_CARD',
  TEN_BIS: 'TEN_BIS',
  CIBUS: 'CIBUS',
  WAITER: 'WAITER'
};
